import React from "react";
import PropTypes from "prop-types";
import { SFStack } from "../grid";
import Typography from "@mui/material/Typography";
import SFStyledSwitch from ".";

const SFToggleSwitch = ({
  offLabel,
  onLabel,
  spacing = 1,
  onChange = () => {},
  checked = false,
  direction = "row",
}) => {
  const onChangeHandler = (e) => {
    onChange(e.target.checked);
  };
  return (
    <SFStack spacing={spacing} direction={direction} alignItems="center">
      {offLabel && (
        <Typography variant="formElementLabel">{offLabel}</Typography>
      )}
      <SFStyledSwitch defaultChecked={checked} onChange={onChangeHandler} />
      {onLabel && <Typography variant="formElementLabel">{onLabel}</Typography>}
    </SFStack>
  );
};

SFToggleSwitch.propTypes = {
  /* Theme variant for label text for both states of the switch */
  variant: PropTypes.shape({
    on: PropTypes.string,
    off: PropTypes.string,
  }),
  /* Label shown when switch is off */
  offLabel: PropTypes.string,
  /* Label shown to switch is on */
  onLabel: PropTypes.string,
  /* Spacing applied between labels and switch */
  spacing: PropTypes.number,
  /* Direction of labels and switch, default is row*/
  direction: PropTypes.oneOf(["row", "column"]),
  /* If true, the component is checked. */
  checked: PropTypes.bool,
  /* If true, the component is disabled. */
  disabled: PropTypes.bool,
  /* Callback fired when the state is changed.*/
  onChange: PropTypes.func,
};

export default SFToggleSwitch;
